





















































































import { defineComponent, onBeforeMount, watch } from '@vue/composition-api';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { sessionHeadersData } from '@/bundles/Session/helpers';
import { useStore } from '@/utils/use-store';
import { useTable } from '@/bundles/BaseTable/composables/useTable';
import { useSession } from "@/composition-functions/useSession";
import { useHomeworkList } from "@/composition-functions/useHomeworkList";
import { useWarmUpList } from "@/composition-functions/useWarmUpList";
import { useSessionExerciseList } from "@/composition-functions/useSessionExerciseList";

import BaseTable from '@/bundles/BaseTable/components/BaseTable.vue';
import QuestionsForm from '@/components/Questions/QuestionsForm.vue';
import SessionForm from "@/components/Session/SessionForm.vue";

export default defineComponent({
  name: 'SessionListTable',

  components: {
    SessionForm,
    BaseTable,
    QuestionsForm,
  },

  emits: ['options:change'],

  props: {
    tableOptionsEntry: {
      type: Object,
      required: true,
    },
    itemsEntry: {
      type: Array,
      default: () => [],
    },
    totalRowsEntry: {
      type: Number,
      default: 0,
    },
    loading: Boolean,
  },

  setup: function (props, { emit }) {
    const store = useStore();
    const { accessToken: token } = store.state.user;
    const {
      exerciseOrderLoading,
      sessionDrawer,
      setDefaultOrder,
      mode,
      tempSession,
      closeDrawerEventHandler,
      toggleDrawerEventHandler,
      createSessionEventHandler,
      editSessionEventHandler,
      changeExerciseOrderHandler
    } = useSession();

    const {
      homeworkList,
      fetchHomeworkList,
    } = useHomeworkList();

    const {
      warmUpList,
      fetchWarmUpList,
    } = useWarmUpList();

    const {
      sessionExerciseList,
      fetchSessionExerciseList,
    } = useSessionExerciseList();

    const { calculateHeight } = useTable();

    onBeforeMount(onBeforeMountEventHandler);

    /**
     * Handler for onBeforeMount event
     * */
    async function onBeforeMountEventHandler() {
      await fetchHomeworkList(token);
      await fetchWarmUpList(token);
      await fetchSessionExerciseList(token);
    }

    function optionsChangeEventHandler(options: ITableOptions) {
      emit('options:change', options);
    }

    function toggleEdit(id: null) {
      tempSession.value = Object.assign({}, props.itemsEntry.find((exercise: any) => exercise.id === id)) || null;
      mode.value = 'edit';
      sessionDrawer.value = true;
    }

    return {
      sessionDrawer,
      setDefaultOrder,
      exerciseOrderLoading,
      mode,
      tempSession,
      homeworkList,
      warmUpList,
      sessionExerciseList,
      closeDrawerEventHandler,
      toggleDrawerEventHandler,
      createSessionEventHandler,
      editSessionEventHandler,
      changeExerciseOrderHandler,
      sessionHeadersData,
      toggleEdit,
      calculateHeight,
      optionsChangeEventHandler,
    };
  },
});
